import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "ssc loseinfo"
};
const _hoisted_2 = {
  class: "title theme-border-half light-bg"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "title theme-border-half light-bg"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = ["onClick"];
const _hoisted_10 = ["onClick"];
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "title theme-border-half light-bg"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = ["onClick"];
const _hoisted_15 = ["onClick"];
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  class: "title theme-border-half light-bg"
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = ["onClick"];
const _hoisted_20 = ["onClick"];
const _hoisted_21 = ["onClick"];
const _hoisted_22 = {
  class: "title theme-border-half light-bg"
};
const _hoisted_23 = ["onClick"];
const _hoisted_24 = ["onClick"];
const _hoisted_25 = ["onClick"];
const _hoisted_26 = ["onClick"];
const _hoisted_27 = {
  class: "title theme-border-half light-bg"
};
const _hoisted_28 = ["onClick"];
const _hoisted_29 = ["onClick"];
const _hoisted_30 = ["onClick"];
const _hoisted_31 = ["onClick"];
const _hoisted_32 = {
  class: "title theme-border-half light-bg"
};
const _hoisted_33 = ["onClick"];
const _hoisted_34 = ["onClick"];
const _hoisted_35 = ["onClick"];
const _hoisted_36 = ["onClick"];
const _hoisted_37 = {
  class: "title theme-border-half light-bg"
};
const _hoisted_38 = ["onClick"];
const _hoisted_39 = ["onClick"];
const _hoisted_40 = ["onClick"];
const _hoisted_41 = ["onClick"];
const _hoisted_42 = {
  class: "title theme-border-half light-bg"
};
const _hoisted_43 = ["onClick"];
const _hoisted_44 = ["onClick"];
const _hoisted_45 = ["onClick"];
const _hoisted_46 = ["onClick"];
const _hoisted_47 = {
  class: "title theme-border-half light-bg"
};
const _hoisted_48 = ["onClick"];
const _hoisted_49 = ["onClick"];
const _hoisted_50 = ["onClick"];
const _hoisted_51 = ["onClick"];
const _hoisted_52 = {
  class: "title theme-border-half light-bg"
};
const _hoisted_53 = ["onClick"];
const _hoisted_54 = ["onClick"];
const _hoisted_55 = ["onClick"];
const _hoisted_56 = ["onClick"];
const _hoisted_57 = {
  class: "title theme-border-half light-bg"
};
const _hoisted_58 = ["onClick"];
const _hoisted_59 = ["onClick"];
const _hoisted_60 = ["onClick"];
const _hoisted_61 = ["onClick"];
const _hoisted_62 = {
  class: "title theme-border-half light-bg"
};
const _hoisted_63 = ["onClick"];
const _hoisted_64 = ["onClick"];
const _hoisted_65 = ["onClick"];
const _hoisted_66 = ["onClick"];
const _hoisted_67 = {
  class: "title theme-border-half light-bg"
};
const _hoisted_68 = ["onClick"];
const _hoisted_69 = ["onClick"];
const _hoisted_70 = ["onClick"];
const _hoisted_71 = ["onClick"];
const _hoisted_72 = {
  class: "title theme-border-half light-bg"
};
const _hoisted_73 = ["onClick"];
const _hoisted_74 = ["onClick"];
const _hoisted_75 = ["onClick"];
const _hoisted_76 = ["onClick"];
const _hoisted_77 = {
  class: "title theme-border-half light-bg"
};
const _hoisted_78 = ["onClick"];
const _hoisted_79 = ["onClick"];
const _hoisted_80 = ["onClick"];
const _hoisted_81 = ["onClick"];
const _hoisted_82 = {
  class: "title theme-border-half light-bg"
};
const _hoisted_83 = ["onClick"];
const _hoisted_84 = ["onClick"];
const _hoisted_85 = ["onClick"];
const _hoisted_86 = ["onClick"];
const _hoisted_87 = {
  class: "title theme-border-half light-bg"
};
const _hoisted_88 = ["onClick"];
const _hoisted_89 = ["onClick"];
const _hoisted_90 = ["onClick"];
const _hoisted_91 = ["onClick"];
const _hoisted_92 = {
  class: "title theme-border-half light-bg"
};
const _hoisted_93 = ["onClick"];
const _hoisted_94 = ["onClick"];
const _hoisted_95 = ["onClick"];
const _hoisted_96 = ["onClick"];
const _hoisted_97 = {
  class: "title theme-border-half light-bg"
};
const _hoisted_98 = ["onClick"];
const _hoisted_99 = ["onClick"];
const _hoisted_100 = ["onClick"];
const _hoisted_101 = ["onClick"];
const _hoisted_102 = {
  class: "title theme-border-half light-bg"
};
const _hoisted_103 = ["onClick"];
const _hoisted_104 = ["onClick"];
const _hoisted_105 = ["onClick"];
const _hoisted_106 = ["onClick"];
const _hoisted_107 = {
  class: "title theme-border-half light-bg"
};
const _hoisted_108 = ["onClick"];
const _hoisted_109 = ["onClick"];
const _hoisted_110 = ["onClick"];
const _hoisted_111 = ["onClick"];
const _hoisted_112 = {
  class: "title theme-border-half light-bg"
};
const _hoisted_113 = ["onClick"];
const _hoisted_114 = ["onClick"];
const _hoisted_115 = ["onClick"];
const _hoisted_116 = ["onClick"];
const _hoisted_117 = {
  class: "title theme-border-half light-bg"
};
const _hoisted_118 = ["onClick"];
const _hoisted_119 = ["onClick"];
const _hoisted_120 = ["onClick"];
const _hoisted_121 = ["onClick"];
const _hoisted_122 = {
  class: "theme-border-half",
  style: {
    "padding": "3px 7px",
    "margin-top": "3px",
    "border": "1px solid"
  }
};

const _hoisted_123 = /*#__PURE__*/_createTextVNode(" 总投注额： ");

const _hoisted_124 = /*#__PURE__*/_createTextVNode(" 最高亏损： ");

const _hoisted_125 = /*#__PURE__*/_createTextVNode(" 最高盈利： ");

const _hoisted_126 = {
  class: "title theme-border-half light-bg"
};

const _hoisted_127 = /*#__PURE__*/_createTextVNode(" 总额： ");

const _hoisted_128 = {
  class: "theme-text"
};
const _hoisted_129 = {
  class: "theme-text num"
};

const _hoisted_130 = /*#__PURE__*/_createElementVNode("div", {
  class: "title theme-border-half light-bg"
}, "两面长龙", -1);

const _hoisted_131 = /*#__PURE__*/_createTextVNode("暂无数据");

const _hoisted_132 = {
  class: "theme-text num"
};
const _hoisted_133 = {
  ref: "pl_popver",
  class: "pl_popver"
};
const _hoisted_134 = {
  class: "pl_popver_title"
};
const _hoisted_135 = {
  style: {
    "text-align": "center"
  }
};

const _hoisted_136 = /*#__PURE__*/_createTextVNode(" 赔率： ");

const _hoisted_137 = {
  style: {
    "margin": "10px",
    "text-align": "center"
  }
};

const _hoisted_138 = /*#__PURE__*/_createTextVNode("  取消  ");

const _hoisted_139 = /*#__PURE__*/_createTextVNode("  确认  ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_table_column = _resolveComponent("el-table-column");

  const _component_el_table = _resolveComponent("el-table");

  const _component_el_col = _resolveComponent("el-col");

  const _component_el_row = _resolveComponent("el-row");

  const _component_el_divider = _resolveComponent("el-divider");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_button = _resolveComponent("el-button");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    gutter: 2
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 20
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        gutter: 2
      }, {
        default: _withCtx(() => [$props.title == '两面' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, _toDisplayString($data.d1[0].game_type), 1), _createVNode(_component_el_table, {
            data: $data.d1,
            border: "",
            size: "small",
            "highlight-current-row": "",
            "header-cell-class-name": "table-header-cell",
            "header-row-class-name": "table-header-row",
            "table-layout": "auto"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              property: "name",
              label: "号",
              align: "center",
              width: "40"
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "赔率",
              align: "center"
            }, {
              default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "plus",
                onClick: $event => $options.show_pl_popver(scope.row, 'plus')
              }, null, 8, _hoisted_3)) : _createCommentVNode("", true), _createElementVNode("span", {
                class: "item-pl",
                onClick: $event => $options.show_pl_popver(scope.row, $event)
              }, _toDisplayString(scope.row.pl), 9, _hoisted_4), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "minus",
                onClick: $event => $options.show_pl_popver(scope.row, 'minus')
              }, null, 8, _hoisted_5)) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "注额",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: {
                  "cursor": "pointer"
                },
                onClick: $event => $options.get_zdmx_data(scope.row)
              }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_6)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "盈亏",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                })
              }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_7, _toDisplayString($data.d2[0].game_type), 1), _createVNode(_component_el_table, {
            data: $data.d2,
            border: "",
            size: "small",
            "highlight-current-row": "",
            "header-cell-class-name": "table-header-cell",
            "header-row-class-name": "table-header-row",
            "table-layout": "auto"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              property: "name",
              label: "号",
              align: "center",
              width: "40"
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "赔率",
              align: "center"
            }, {
              default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "plus",
                onClick: $event => $options.show_pl_popver(scope.row, 'plus')
              }, null, 8, _hoisted_8)) : _createCommentVNode("", true), _createElementVNode("span", {
                class: "item-pl",
                onClick: $event => $options.show_pl_popver(scope.row, $event)
              }, _toDisplayString(scope.row.pl), 9, _hoisted_9), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "minus",
                onClick: $event => $options.show_pl_popver(scope.row, 'minus')
              }, null, 8, _hoisted_10)) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "注额",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: {
                  "cursor": "pointer"
                },
                onClick: $event => $options.get_zdmx_data(scope.row)
              }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_11)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "盈亏",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                })
              }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_12, _toDisplayString($data.d3[0].game_type), 1), _createVNode(_component_el_table, {
            data: $data.d3,
            border: "",
            size: "small",
            "highlight-current-row": "",
            "header-cell-class-name": "table-header-cell",
            "header-row-class-name": "table-header-row",
            "table-layout": "auto"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              property: "name",
              label: "号",
              align: "center",
              width: "40"
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "赔率",
              align: "center"
            }, {
              default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "plus",
                onClick: $event => $options.show_pl_popver(scope.row, 'plus')
              }, null, 8, _hoisted_13)) : _createCommentVNode("", true), _createElementVNode("span", {
                class: "item-pl",
                onClick: $event => $options.show_pl_popver(scope.row, $event)
              }, _toDisplayString(scope.row.pl), 9, _hoisted_14), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "minus",
                onClick: $event => $options.show_pl_popver(scope.row, 'minus')
              }, null, 8, _hoisted_15)) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "注额",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: {
                  "cursor": "pointer"
                },
                onClick: $event => $options.get_zdmx_data(scope.row)
              }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_16)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "盈亏",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                })
              }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_17, _toDisplayString($data.d4[0].game_type), 1), _createVNode(_component_el_table, {
            data: $data.d4,
            border: "",
            size: "small",
            "highlight-current-row": "",
            "header-cell-class-name": "table-header-cell",
            "header-row-class-name": "table-header-row",
            "table-layout": "auto"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              property: "name",
              label: "号",
              align: "center",
              width: "40"
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "赔率",
              align: "center"
            }, {
              default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "plus",
                onClick: $event => $options.show_pl_popver(scope.row, 'plus')
              }, null, 8, _hoisted_18)) : _createCommentVNode("", true), _createElementVNode("span", {
                class: "item-pl",
                onClick: $event => $options.show_pl_popver(scope.row, $event)
              }, _toDisplayString(scope.row.pl), 9, _hoisted_19), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "minus",
                onClick: $event => $options.show_pl_popver(scope.row, 'minus')
              }, null, 8, _hoisted_20)) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "注额",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: {
                  "cursor": "pointer"
                },
                onClick: $event => $options.get_zdmx_data(scope.row)
              }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_21)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "盈亏",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                })
              }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_22, _toDisplayString($data.d5[0].game_type), 1), _createVNode(_component_el_table, {
            data: $data.d5,
            border: "",
            size: "small",
            "highlight-current-row": "",
            "header-cell-class-name": "table-header-cell",
            "header-row-class-name": "table-header-row",
            "table-layout": "auto"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              property: "name",
              label: "号",
              align: "center",
              width: "40"
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "赔率",
              align: "center"
            }, {
              default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "plus",
                onClick: $event => $options.show_pl_popver(scope.row, 'plus')
              }, null, 8, _hoisted_23)) : _createCommentVNode("", true), _createElementVNode("span", {
                class: "item-pl",
                onClick: $event => $options.show_pl_popver(scope.row, $event)
              }, _toDisplayString(scope.row.pl), 9, _hoisted_24), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "minus",
                onClick: $event => $options.show_pl_popver(scope.row, 'minus')
              }, null, 8, _hoisted_25)) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "注额",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: {
                  "cursor": "pointer"
                },
                onClick: $event => $options.get_zdmx_data(scope.row)
              }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_26)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "盈亏",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                })
              }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_27, _toDisplayString($data.q3[0].game_type), 1), _createVNode(_component_el_table, {
            data: $data.q3,
            border: "",
            size: "small",
            "highlight-current-row": "",
            "header-cell-class-name": "table-header-cell",
            "header-row-class-name": "table-header-row",
            "table-layout": "auto"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              property: "name",
              label: "号",
              align: "center",
              width: "40"
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "赔率",
              align: "center"
            }, {
              default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "plus",
                onClick: $event => $options.show_pl_popver(scope.row, 'plus')
              }, null, 8, _hoisted_28)) : _createCommentVNode("", true), _createElementVNode("span", {
                class: "item-pl",
                onClick: $event => $options.show_pl_popver(scope.row, $event)
              }, _toDisplayString(scope.row.pl), 9, _hoisted_29), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "minus",
                onClick: $event => $options.show_pl_popver(scope.row, 'minus')
              }, null, 8, _hoisted_30)) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "注额",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: {
                  "cursor": "pointer"
                },
                onClick: $event => $options.get_zdmx_data(scope.row)
              }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_31)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "盈亏",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                })
              }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_32, _toDisplayString($data.z3[0].game_type), 1), _createVNode(_component_el_table, {
            data: $data.z3,
            border: "",
            size: "small",
            "highlight-current-row": "",
            "header-cell-class-name": "table-header-cell",
            "header-row-class-name": "table-header-row",
            "table-layout": "auto"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              property: "name",
              label: "号",
              align: "center",
              width: "40"
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "赔率",
              align: "center"
            }, {
              default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "plus",
                onClick: $event => $options.show_pl_popver(scope.row, 'plus')
              }, null, 8, _hoisted_33)) : _createCommentVNode("", true), _createElementVNode("span", {
                class: "item-pl",
                onClick: $event => $options.show_pl_popver(scope.row, $event)
              }, _toDisplayString(scope.row.pl), 9, _hoisted_34), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "minus",
                onClick: $event => $options.show_pl_popver(scope.row, 'minus')
              }, null, 8, _hoisted_35)) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "注额",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: {
                  "cursor": "pointer"
                },
                onClick: $event => $options.get_zdmx_data(scope.row)
              }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_36)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "盈亏",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                })
              }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_37, _toDisplayString($data.h3[0].game_type), 1), _createVNode(_component_el_table, {
            data: $data.h3,
            border: "",
            size: "small",
            "highlight-current-row": "",
            "header-cell-class-name": "table-header-cell",
            "header-row-class-name": "table-header-row",
            "table-layout": "auto"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              property: "name",
              label: "号",
              align: "center",
              width: "40"
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "赔率",
              align: "center"
            }, {
              default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "plus",
                onClick: $event => $options.show_pl_popver(scope.row, 'plus')
              }, null, 8, _hoisted_38)) : _createCommentVNode("", true), _createElementVNode("span", {
                class: "item-pl",
                onClick: $event => $options.show_pl_popver(scope.row, $event)
              }, _toDisplayString(scope.row.pl), 9, _hoisted_39), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "minus",
                onClick: $event => $options.show_pl_popver(scope.row, 'minus')
              }, null, 8, _hoisted_40)) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "注额",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: {
                  "cursor": "pointer"
                },
                onClick: $event => $options.get_zdmx_data(scope.row)
              }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_41)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "盈亏",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                })
              }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_42, _toDisplayString($data.zh[0].game_type), 1), _createVNode(_component_el_table, {
            data: $data.zh,
            border: "",
            size: "small",
            "highlight-current-row": "",
            "header-cell-class-name": "table-header-cell",
            "header-row-class-name": "table-header-row",
            "table-layout": "auto"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              property: "name",
              label: "号",
              align: "center",
              width: "45"
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "赔率",
              align: "center"
            }, {
              default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "plus",
                onClick: $event => $options.show_pl_popver(scope.row, 'plus')
              }, null, 8, _hoisted_43)) : _createCommentVNode("", true), _createElementVNode("span", {
                class: "item-pl",
                onClick: $event => $options.show_pl_popver(scope.row, $event)
              }, _toDisplayString(scope.row.pl), 9, _hoisted_44), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "minus",
                onClick: $event => $options.show_pl_popver(scope.row, 'minus')
              }, null, 8, _hoisted_45)) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "注额",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: {
                  "cursor": "pointer"
                },
                onClick: $event => $options.get_zdmx_data(scope.row)
              }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_46)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "盈亏",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                })
              }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_47, _toDisplayString($data.lh1v2[0].game_type), 1), _createVNode(_component_el_table, {
            data: $data.lh1v2,
            border: "",
            size: "small",
            "highlight-current-row": "",
            "header-cell-class-name": "table-header-cell",
            "header-row-class-name": "table-header-row",
            "table-layout": "auto"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              property: "name",
              label: "号",
              align: "center",
              width: "40"
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "赔率",
              align: "center"
            }, {
              default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "plus",
                onClick: $event => $options.show_pl_popver(scope.row, 'plus')
              }, null, 8, _hoisted_48)) : _createCommentVNode("", true), _createElementVNode("span", {
                class: "item-pl",
                onClick: $event => $options.show_pl_popver(scope.row, $event)
              }, _toDisplayString(scope.row.pl), 9, _hoisted_49), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "minus",
                onClick: $event => $options.show_pl_popver(scope.row, 'minus')
              }, null, 8, _hoisted_50)) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "注额",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: {
                  "cursor": "pointer"
                },
                onClick: $event => $options.get_zdmx_data(scope.row)
              }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_51)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "盈亏",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                })
              }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_52, _toDisplayString($data.lh1v3[0].game_type), 1), _createVNode(_component_el_table, {
            data: $data.lh1v3,
            border: "",
            size: "small",
            "highlight-current-row": "",
            "header-cell-class-name": "table-header-cell",
            "header-row-class-name": "table-header-row",
            "table-layout": "auto"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              property: "name",
              label: "号",
              align: "center",
              width: "40"
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "赔率",
              align: "center"
            }, {
              default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "plus",
                onClick: $event => $options.show_pl_popver(scope.row, 'plus')
              }, null, 8, _hoisted_53)) : _createCommentVNode("", true), _createElementVNode("span", {
                class: "item-pl",
                onClick: $event => $options.show_pl_popver(scope.row, $event)
              }, _toDisplayString(scope.row.pl), 9, _hoisted_54), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "minus",
                onClick: $event => $options.show_pl_popver(scope.row, 'minus')
              }, null, 8, _hoisted_55)) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "注额",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: {
                  "cursor": "pointer"
                },
                onClick: $event => $options.get_zdmx_data(scope.row)
              }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_56)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "盈亏",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                })
              }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_57, _toDisplayString($data.lh1v4[0].game_type), 1), _createVNode(_component_el_table, {
            data: $data.lh1v4,
            border: "",
            size: "small",
            "highlight-current-row": "",
            "header-cell-class-name": "table-header-cell",
            "header-row-class-name": "table-header-row",
            "table-layout": "auto"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              property: "name",
              label: "号",
              align: "center",
              width: "40"
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "赔率",
              align: "center"
            }, {
              default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "plus",
                onClick: $event => $options.show_pl_popver(scope.row, 'plus')
              }, null, 8, _hoisted_58)) : _createCommentVNode("", true), _createElementVNode("span", {
                class: "item-pl",
                onClick: $event => $options.show_pl_popver(scope.row, $event)
              }, _toDisplayString(scope.row.pl), 9, _hoisted_59), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "minus",
                onClick: $event => $options.show_pl_popver(scope.row, 'minus')
              }, null, 8, _hoisted_60)) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "注额",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: {
                  "cursor": "pointer"
                },
                onClick: $event => $options.get_zdmx_data(scope.row)
              }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_61)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "盈亏",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                })
              }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_62, _toDisplayString($data.lh1V5[0].game_type), 1), _createVNode(_component_el_table, {
            data: $data.lh1V5,
            border: "",
            size: "small",
            "highlight-current-row": "",
            "header-cell-class-name": "table-header-cell",
            "header-row-class-name": "table-header-row",
            "table-layout": "auto"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              property: "name",
              label: "号",
              align: "center",
              width: "40"
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "赔率",
              align: "center"
            }, {
              default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "plus",
                onClick: $event => $options.show_pl_popver(scope.row, 'plus')
              }, null, 8, _hoisted_63)) : _createCommentVNode("", true), _createElementVNode("span", {
                class: "item-pl",
                onClick: $event => $options.show_pl_popver(scope.row, $event)
              }, _toDisplayString(scope.row.pl), 9, _hoisted_64), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "minus",
                onClick: $event => $options.show_pl_popver(scope.row, 'minus')
              }, null, 8, _hoisted_65)) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "注额",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: {
                  "cursor": "pointer"
                },
                onClick: $event => $options.get_zdmx_data(scope.row)
              }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_66)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "盈亏",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                })
              }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_67, _toDisplayString($data.lh2V3[0].game_type), 1), _createVNode(_component_el_table, {
            data: $data.lh2V3,
            border: "",
            size: "small",
            "highlight-current-row": "",
            "header-cell-class-name": "table-header-cell",
            "header-row-class-name": "table-header-row",
            "table-layout": "auto"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              property: "name",
              label: "号",
              align: "center",
              width: "40"
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "赔率",
              align: "center"
            }, {
              default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "plus",
                onClick: $event => $options.show_pl_popver(scope.row, 'plus')
              }, null, 8, _hoisted_68)) : _createCommentVNode("", true), _createElementVNode("span", {
                class: "item-pl",
                onClick: $event => $options.show_pl_popver(scope.row, $event)
              }, _toDisplayString(scope.row.pl), 9, _hoisted_69), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "minus",
                onClick: $event => $options.show_pl_popver(scope.row, 'minus')
              }, null, 8, _hoisted_70)) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "注额",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: {
                  "cursor": "pointer"
                },
                onClick: $event => $options.get_zdmx_data(scope.row)
              }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_71)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "盈亏",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                })
              }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_72, _toDisplayString($data.lh2V4[0].game_type), 1), _createVNode(_component_el_table, {
            data: $data.lh2V4,
            border: "",
            size: "small",
            "highlight-current-row": "",
            "header-cell-class-name": "table-header-cell",
            "header-row-class-name": "table-header-row",
            "table-layout": "auto"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              property: "name",
              label: "号",
              align: "center",
              width: "40"
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "赔率",
              align: "center"
            }, {
              default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "plus",
                onClick: $event => $options.show_pl_popver(scope.row, 'plus')
              }, null, 8, _hoisted_73)) : _createCommentVNode("", true), _createElementVNode("span", {
                class: "item-pl",
                onClick: $event => $options.show_pl_popver(scope.row, $event)
              }, _toDisplayString(scope.row.pl), 9, _hoisted_74), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "minus",
                onClick: $event => $options.show_pl_popver(scope.row, 'minus')
              }, null, 8, _hoisted_75)) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "注额",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: {
                  "cursor": "pointer"
                },
                onClick: $event => $options.get_zdmx_data(scope.row)
              }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_76)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "盈亏",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                })
              }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_77, _toDisplayString($data.lh2V5[0].game_type), 1), _createVNode(_component_el_table, {
            data: $data.lh2V5,
            border: "",
            size: "small",
            "highlight-current-row": "",
            "header-cell-class-name": "table-header-cell",
            "header-row-class-name": "table-header-row",
            "table-layout": "auto"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              property: "name",
              label: "号",
              align: "center",
              width: "40"
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "赔率",
              align: "center"
            }, {
              default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "plus",
                onClick: $event => $options.show_pl_popver(scope.row, 'plus')
              }, null, 8, _hoisted_78)) : _createCommentVNode("", true), _createElementVNode("span", {
                class: "item-pl",
                onClick: $event => $options.show_pl_popver(scope.row, $event)
              }, _toDisplayString(scope.row.pl), 9, _hoisted_79), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "minus",
                onClick: $event => $options.show_pl_popver(scope.row, 'minus')
              }, null, 8, _hoisted_80)) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "注额",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: {
                  "cursor": "pointer"
                },
                onClick: $event => $options.get_zdmx_data(scope.row)
              }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_81)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "盈亏",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                })
              }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_82, _toDisplayString($data.lh3V4[0].game_type), 1), _createVNode(_component_el_table, {
            data: $data.lh3V4,
            border: "",
            size: "small",
            "highlight-current-row": "",
            "header-cell-class-name": "table-header-cell",
            "header-row-class-name": "table-header-row",
            "table-layout": "auto"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              property: "name",
              label: "号",
              align: "center",
              width: "40"
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "赔率",
              align: "center"
            }, {
              default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "plus",
                onClick: $event => $options.show_pl_popver(scope.row, 'plus')
              }, null, 8, _hoisted_83)) : _createCommentVNode("", true), _createElementVNode("span", {
                class: "item-pl",
                onClick: $event => $options.show_pl_popver(scope.row, $event)
              }, _toDisplayString(scope.row.pl), 9, _hoisted_84), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "minus",
                onClick: $event => $options.show_pl_popver(scope.row, 'minus')
              }, null, 8, _hoisted_85)) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "注额",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: {
                  "cursor": "pointer"
                },
                onClick: $event => $options.get_zdmx_data(scope.row)
              }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_86)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "盈亏",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                })
              }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_87, _toDisplayString($data.lh3V5[0].game_type), 1), _createVNode(_component_el_table, {
            data: $data.lh3V5,
            border: "",
            size: "small",
            "highlight-current-row": "",
            "header-cell-class-name": "table-header-cell",
            "header-row-class-name": "table-header-row",
            "table-layout": "auto"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              property: "name",
              label: "号",
              align: "center",
              width: "40"
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "赔率",
              align: "center"
            }, {
              default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "plus",
                onClick: $event => $options.show_pl_popver(scope.row, 'plus')
              }, null, 8, _hoisted_88)) : _createCommentVNode("", true), _createElementVNode("span", {
                class: "item-pl",
                onClick: $event => $options.show_pl_popver(scope.row, $event)
              }, _toDisplayString(scope.row.pl), 9, _hoisted_89), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "minus",
                onClick: $event => $options.show_pl_popver(scope.row, 'minus')
              }, null, 8, _hoisted_90)) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "注额",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: {
                  "cursor": "pointer"
                },
                onClick: $event => $options.get_zdmx_data(scope.row)
              }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_91)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "盈亏",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                })
              }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_92, _toDisplayString($data.lh4V5[0].game_type), 1), _createVNode(_component_el_table, {
            data: $data.lh4V5,
            border: "",
            size: "small",
            "highlight-current-row": "",
            "header-cell-class-name": "table-header-cell",
            "header-row-class-name": "table-header-row",
            "table-layout": "auto"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              property: "name",
              label: "号",
              align: "center",
              width: "40"
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "赔率",
              align: "center"
            }, {
              default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "plus",
                onClick: $event => $options.show_pl_popver(scope.row, 'plus')
              }, null, 8, _hoisted_93)) : _createCommentVNode("", true), _createElementVNode("span", {
                class: "item-pl",
                onClick: $event => $options.show_pl_popver(scope.row, $event)
              }, _toDisplayString(scope.row.pl), 9, _hoisted_94), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "minus",
                onClick: $event => $options.show_pl_popver(scope.row, 'minus')
              }, null, 8, _hoisted_95)) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "注额",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: {
                  "cursor": "pointer"
                },
                onClick: $event => $options.get_zdmx_data(scope.row)
              }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_96)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "title",
              label: "盈亏",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                })
              }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])]),
          _: 1
        })], 64)) : _createCommentVNode("", true), $props.title == '1-5球' ? (_openBlock(), _createBlock(_component_el_row, {
          key: 1,
          gutter: 2
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_el_row, null, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                span: 8
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_97, _toDisplayString($data.dd1[0].game_type), 1), _createVNode(_component_el_table, {
                  data: $data.dd1,
                  border: "",
                  size: "small",
                  "highlight-current-row": "",
                  "header-cell-class-name": "table-header-cell",
                  "header-row-class-name": "table-header-row",
                  "table-layout": "auto"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_table_column, {
                    property: "name",
                    label: "号码",
                    align: "center",
                    width: "40"
                  }), _createVNode(_component_el_table_column, {
                    property: "title",
                    label: "赔率",
                    align: "center"
                  }, {
                    default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "plus",
                      onClick: $event => $options.show_pl_popver(scope.row, 'plus')
                    }, null, 8, _hoisted_98)) : _createCommentVNode("", true), _createElementVNode("span", {
                      class: "item-pl",
                      onClick: $event => $options.show_pl_popver(scope.row, $event)
                    }, _toDisplayString(scope.row.pl), 9, _hoisted_99), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "minus",
                      onClick: $event => $options.show_pl_popver(scope.row, 'minus')
                    }, null, 8, _hoisted_100)) : _createCommentVNode("", true)]),
                    _: 1
                  }), _createVNode(_component_el_table_column, {
                    property: "title",
                    label: "注额",
                    align: "center"
                  }, {
                    default: _withCtx(scope => [_createElementVNode("span", {
                      style: {
                        "cursor": "pointer"
                      },
                      onClick: $event => $options.get_zdmx_data(scope.row)
                    }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_101)]),
                    _: 1
                  }), _createVNode(_component_el_table_column, {
                    property: "title",
                    label: "盈亏",
                    align: "center"
                  }, {
                    default: _withCtx(scope => [_createElementVNode("span", {
                      style: _normalizeStyle({
                        color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                      })
                    }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["data"])]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 8
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_102, _toDisplayString($data.dd2[0].game_type), 1), _createVNode(_component_el_table, {
                  data: $data.dd2,
                  border: "",
                  size: "small",
                  "highlight-current-row": "",
                  "header-cell-class-name": "table-header-cell",
                  "header-row-class-name": "table-header-row",
                  "table-layout": "auto"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_table_column, {
                    property: "name",
                    label: "号码",
                    align: "center",
                    width: "40"
                  }), _createVNode(_component_el_table_column, {
                    property: "title",
                    label: "赔率",
                    align: "center"
                  }, {
                    default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "plus",
                      onClick: $event => $options.show_pl_popver(scope.row, 'plus')
                    }, null, 8, _hoisted_103)) : _createCommentVNode("", true), _createElementVNode("span", {
                      class: "item-pl",
                      onClick: $event => $options.show_pl_popver(scope.row, $event)
                    }, _toDisplayString(scope.row.pl), 9, _hoisted_104), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: "minus",
                      onClick: $event => $options.show_pl_popver(scope.row, 'minus')
                    }, null, 8, _hoisted_105)) : _createCommentVNode("", true)]),
                    _: 1
                  }), _createVNode(_component_el_table_column, {
                    property: "title",
                    label: "注额",
                    align: "center"
                  }, {
                    default: _withCtx(scope => [_createElementVNode("span", {
                      style: {
                        "cursor": "pointer"
                      },
                      onClick: $event => $options.get_zdmx_data(scope.row)
                    }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_106)]),
                    _: 1
                  }), _createVNode(_component_el_table_column, {
                    property: "title",
                    label: "盈亏",
                    align: "center"
                  }, {
                    default: _withCtx(scope => [_createElementVNode("span", {
                      style: _normalizeStyle({
                        color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                      })
                    }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["data"])]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 8
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_107, _toDisplayString($data.dd3[0].game_type), 1), _createVNode(_component_el_table, {
                  data: $data.dd3,
                  border: "",
                  size: "small",
                  "highlight-current-row": "",
                  "header-cell-class-name": "table-header-cell",
                  "header-row-class-name": "table-header-row",
                  "table-layout": "auto"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_table_column, {
                    property: "name",
                    label: "号码",
                    align: "center",
                    width: "40"
                  }), _createVNode(_component_el_table_column, {
                    property: "title",
                    label: "赔率",
                    align: "center"
                  }, {
                    default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "plus",
                      onClick: $event => $options.show_pl_popver(scope.row, 'plus')
                    }, null, 8, _hoisted_108)) : _createCommentVNode("", true), _createElementVNode("span", {
                      class: "item-pl",
                      onClick: $event => $options.show_pl_popver(scope.row, $event)
                    }, _toDisplayString(scope.row.pl), 9, _hoisted_109), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: "minus",
                      onClick: $event => $options.show_pl_popver(scope.row, 'minus')
                    }, null, 8, _hoisted_110)) : _createCommentVNode("", true)]),
                    _: 1
                  }), _createVNode(_component_el_table_column, {
                    property: "title",
                    label: "注额",
                    align: "center"
                  }, {
                    default: _withCtx(scope => [_createElementVNode("span", {
                      style: {
                        "cursor": "pointer"
                      },
                      onClick: $event => $options.get_zdmx_data(scope.row)
                    }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_111)]),
                    _: 1
                  }), _createVNode(_component_el_table_column, {
                    property: "title",
                    label: "盈亏",
                    align: "center"
                  }, {
                    default: _withCtx(scope => [_createElementVNode("span", {
                      style: _normalizeStyle({
                        color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                      })
                    }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["data"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_el_row, {
              gutter: 2
            }, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                span: 8
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_112, _toDisplayString($data.dd4[0].game_type), 1), _createVNode(_component_el_table, {
                  data: $data.dd4,
                  border: "",
                  size: "small",
                  "highlight-current-row": "",
                  "header-cell-class-name": "table-header-cell",
                  "header-row-class-name": "table-header-row",
                  "table-layout": "auto"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_table_column, {
                    property: "name",
                    label: "号码",
                    align: "center",
                    width: "40"
                  }), _createVNode(_component_el_table_column, {
                    property: "title",
                    label: "赔率",
                    align: "center"
                  }, {
                    default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "plus",
                      onClick: $event => $options.show_pl_popver(scope.row, 'plus')
                    }, null, 8, _hoisted_113)) : _createCommentVNode("", true), _createElementVNode("span", {
                      class: "item-pl",
                      onClick: $event => $options.show_pl_popver(scope.row, $event)
                    }, _toDisplayString(scope.row.pl), 9, _hoisted_114), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: "minus",
                      onClick: $event => $options.show_pl_popver(scope.row, 'minus')
                    }, null, 8, _hoisted_115)) : _createCommentVNode("", true)]),
                    _: 1
                  }), _createVNode(_component_el_table_column, {
                    property: "title",
                    label: "注额",
                    align: "center"
                  }, {
                    default: _withCtx(scope => [_createElementVNode("span", {
                      style: {
                        "cursor": "pointer"
                      },
                      onClick: $event => $options.get_zdmx_data(scope.row)
                    }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_116)]),
                    _: 1
                  }), _createVNode(_component_el_table_column, {
                    property: "title",
                    label: "盈亏",
                    align: "center"
                  }, {
                    default: _withCtx(scope => [_createElementVNode("span", {
                      style: _normalizeStyle({
                        color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                      })
                    }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["data"])]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 8
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_117, _toDisplayString($data.dd5[0].game_type), 1), _createVNode(_component_el_table, {
                  data: $data.dd5,
                  border: "",
                  size: "small",
                  "highlight-current-row": "",
                  "header-cell-class-name": "table-header-cell",
                  "header-row-class-name": "table-header-row",
                  "table-layout": "auto"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_table_column, {
                    property: "name",
                    label: "号码",
                    align: "center",
                    width: "40"
                  }), _createVNode(_component_el_table_column, {
                    property: "title",
                    label: "赔率",
                    align: "center"
                  }, {
                    default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "plus",
                      onClick: $event => $options.show_pl_popver(scope.row, 'plus')
                    }, null, 8, _hoisted_118)) : _createCommentVNode("", true), _createElementVNode("span", {
                      class: "item-pl",
                      onClick: $event => $options.show_pl_popver(scope.row, $event)
                    }, _toDisplayString(scope.row.pl), 9, _hoisted_119), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: "minus",
                      onClick: $event => $options.show_pl_popver(scope.row, 'minus')
                    }, null, 8, _hoisted_120)) : _createCommentVNode("", true)]),
                    _: 1
                  }), _createVNode(_component_el_table_column, {
                    property: "title",
                    label: "注额",
                    align: "center"
                  }, {
                    default: _withCtx(scope => [_createElementVNode("span", {
                      style: {
                        "cursor": "pointer"
                      },
                      onClick: $event => $options.get_zdmx_data(scope.row)
                    }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_121)]),
                    _: 1
                  }), _createVNode(_component_el_table_column, {
                    property: "title",
                    label: "盈亏",
                    align: "center"
                  }, {
                    default: _withCtx(scope => [_createElementVNode("span", {
                      style: _normalizeStyle({
                        color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
                      })
                    }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["data"])]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 8
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_122, [_createElementVNode("p", null, [_hoisted_123, _createElementVNode("span", null, _toDisplayString($props.sum.all_balance), 1)]), _createElementVNode("p", null, [_hoisted_124, _createElementVNode("span", null, _toDisplayString($data.max_ks), 1)]), _createElementVNode("p", null, [_hoisted_125, _createElementVNode("span", null, _toDisplayString($data.max_yl), 1)])])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 4
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        gutter: 2
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_126, [_hoisted_127, _createElementVNode("span", _hoisted_128, _toDisplayString($props.sum.all_balance), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.sum.sums, item => {
            return _openBlock(), _createElementBlock("div", {
              class: "cl-item theme-border-half light-bg",
              key: item.index
            }, [_createElementVNode("span", null, _toDisplayString(item.name), 1), _createElementVNode("span", _hoisted_129, _toDisplayString(item.all_balance), 1)]);
          }), 128))]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_hoisted_130, $props.chang_long.length == 0 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_hoisted_131], 64)) : (_openBlock(true), _createElementBlock(_Fragment, {
            key: 1
          }, _renderList($props.chang_long, item => {
            return _openBlock(), _createElementBlock("div", {
              class: "cl-item theme-border-half light-bg",
              key: item.index
            }, [_createTextVNode(_toDisplayString(item.title) + "-" + _toDisplayString(item.name) + " ", 1), _createElementVNode("span", _hoisted_132, _toDisplayString(item.b_s_qnum) + "期", 1)]);
          }), 128))]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }), _withDirectives(_createElementVNode("div", _hoisted_133, [_createElementVNode("div", _hoisted_134, "修改赔率:" + _toDisplayString($data.pl_popver.row.name), 1), _createElementVNode("div", null, [_createVNode(_component_el_divider, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.pl_popver.value), 1)]),
    _: 1
  })]), _createElementVNode("div", _hoisted_135, [_hoisted_136, _createVNode(_component_el_input, {
    style: {
      "width": "80px"
    },
    modelValue: $data.pl_popver.pl_change_value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.pl_popver.pl_change_value = $event),
    size: "small",
    min: "0"
  }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_137, [_createVNode(_component_el_button, {
    size: "small",
    onClick: _cache[1] || (_cache[1] = $event => $data.pl_popver.show = false)
  }, {
    default: _withCtx(() => [_hoisted_138]),
    _: 1
  }), _createVNode(_component_el_button, {
    type: "primary",
    size: "small",
    onClick: $options.sub_change_pl
  }, {
    default: _withCtx(() => [_hoisted_139]),
    _: 1
  }, 8, ["onClick"])])], 512), [[_vShow, $data.pl_popver.show]])]);
}